<template>
   <div v-if="info">
      <div
         v-for="(item, index) of info"
         :key="index"
      >
         <v-btn
            v-if="item.type === 'link'"
            @click="handleGoTo(item.value)"
            :color="color"
            block
            :dark="isDark"
         >
            {{item.label}}
         </v-btn>
         <div 
            v-else
         >
            <p style="margin-bottom: 0;">
               {{ item.label }}
            </p>
            <p style="font-size: 10px;">
               {{ item.value }}
            </p>
         </div>
      </div>
   </div>
</template>
<script>
import axios from 'axios'
import tinycolor from 'tinycolor2'
import utils from '@/services/utils'
export default {
   props: {
      activityID: {
         type: String,
         required: true,
      },
      locale: {
         type: String,
         required: true,
      },
      color: {
         type: String,
         default: 'black'
      },
   },
   data: () => ({
      info: null,
   }),
   computed: {
      isDark () {
         return tinycolor(this.color).isLight() ? false : true
      },
   },
   watch: {
      activityID () {
         this.handleGetData()
      },
      locale () {
         this.handleGetData()
      },
   },
   mounted () {
      this.handleGetData()
   },
   methods: {
      handleGetData () {
         const url = `${window.location.protocol}//${process.env.VUE_APP_API_URL_CMBOOKING}/v1/public/activities/${this.activityID}/custom-fields-info-data`
         axios.get(url)
            .then((response) => {
               if (!response || !response.data || !response.data.values) return
               this.info = []
               //this.info = response.data
               for (const item of response.data.fields) {
                  const aux = {
                     type: item.Type
                  }
                  if (item.Type === 'link') {
                     const v = response.data.values[item.ID]
                     aux.label = v.text ? utils.getTranslation(v.text, this.locale) : null
                     aux.value = v.link ? utils.getTranslation(v.link, this.locale) : null

                  } else {
                     aux.label = item.Name ? utils.getTranslation(item.Name, this.locale) : null
                     const v = response.data.values[item.ID]
                     aux.value = v ? utils.getTranslation(v, this.locale) : null
                  }

                  if (aux.type && aux.label && aux.label.length > 0 && aux.value && aux.value.length > 0) this.info.push(aux)
               }
            })
            .catch(error => {
               console.log('jjh', error)
            })
      },
      getValue(id, label, type, values) {
         if (!values || values.length === 0) return
         const aux = JSON.parse(values.shift().Values)
         if (type !== 'link') {
            if (!aux || !aux[id]) return
            const value = utils.getTranslation(aux[id], locale)
            if (!value)
            return { label, value: aux[id] }
         }
      },
      handleGoTo (v) {
         window.open(v, '_blank')
      },
   },
}
</script>

